import { Pipe, PipeTransform } from '@angular/core';

/**
 * Replaces newline characters with <br> for use with [innerHTML].
 * Handles both literal sequences (e.g. "\\n" from double-escaped JSON) and actual newline chars.
 * Use with property binding: [innerHTML]="value | lineBreaks"
 */
@Pipe({
    name: 'lineBreaks',
    standalone: false
})
export class LineBreaksPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (value == null) {
      return '';
    }
    return String(value)
      .replace(/\\r\\n/g, '<br>')
      .replace(/\\n/g, '<br>')
      .replace(/\\r/g, '<br>')
      .replace(/\r\n/g, '<br>')
      .replace(/\n/g, '<br>')
      .replace(/\r/g, '<br>');
  }
}
